<div id="sync-setup-component">
    <mat-list class="setup-options">
        <mat-list-item class="setup-service-row">
            <button mat-raised-button id="dropbox-sync-setup" class="setup-button button" (click)="setupDropbox()" [disabled]="dropboxSetup">Dropbox</button>
            <span>{{dropboxMessage}}</span>
        </mat-list-item>
    </mat-list>
</div>